import { API_BASE_URL } from '@/constants/api';

export const NEW_EXPENSE_ATTACHMENT_UPLOAD_ENDPOINT = {
  personal: `${API_BASE_URL}/Expense/attachment/employee`,
  project: `${API_BASE_URL}/Expense/attachment/project`,
};

// to be used with replacing {expenseId} with actual id
export const EDIT_EXPENSE_ATTACHMENT_UPLOAD_ENDPOINT = {
  personal: `${API_BASE_URL}/Expense/{expenseId}/attachment`,
  project: `${API_BASE_URL}/Expense/{expenseId}/attachment`,
};
